import { createUseStyles } from "react-jss";

export default createUseStyles({
    imageAreaSelection: {
        composes: "image-area__selection",
        content: "",
        cursor: "pointer",
        display: "inline-block",
        lineHeight: 0,
        maxWidth: "100%",
        opacity: 0,
        outline: "none",
        position: "absolute",
        transition: "background 200ms, opacity 200ms",
    },
    imageAreaSelectionSelected: {
        background: ({ theme }) => theme.PrimaryColor,
        composes: "image-area__selection--selected",
        opacity: 0.3,
    },
    imageAreaSelectionActive: {
        background: "#999",
        composes: "image-area__selection--active",
        opacity: 0.5,
    },
});
